import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Warning } from "@phosphor-icons/react";
import { fmtMoney, fmtDate } from "@/lib/api";

export default function DeleteFacturaCobrosDialog({ delCobros, isVenta, onCancel, onConfirm }) {
  return (
    <AlertDialog open={!!delCobros} onOpenChange={(v) => !v && onCancel()}>
      <AlertDialogContent className="max-w-lg">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-heading flex items-center gap-2">
            <Warning size={18} weight="fill" className="text-amber-600" />
            La factura tiene {isVenta ? "cobros" : "pagos"} asociados
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-[13px]">
              <p>
                El comprobante <span className="font-mono">{delCobros?.factura.tipo_comprobante} {delCobros?.factura.numero}</span>{" "}
                tiene {delCobros?.cobros.length} {isVenta ? "cobro(s)" : "pago(s)"} vinculado(s).
              </p>
              <div className="border border-amber-200 rounded-sm bg-amber-50 p-3 space-y-2">
                {delCobros?.cobros.map((c) => (
                  <div key={c.id} className="text-[12px] font-mono">
                    <div>
                      {fmtDate(c.fecha)} · <span className="font-semibold">{fmtMoney(c.monto, c.moneda)}</span>{" "}
                      <span className="text-[#666]">→ {c.caja_nombre}</span>
                    </div>
                    {c.facturas_aplicadas?.length > 1 && (
                      <div className="text-[11px] text-amber-800 mt-0.5">
                        ⚠ Este {isVenta ? "cobro" : "pago"} está aplicado a {c.facturas_aplicadas.length} facturas.
                      </div>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-red-700 font-semibold">
                Al confirmar, se eliminarán <span className="underline">completamente</span> los{" "}
                {isVenta ? "cobros" : "pagos"} listados (incluso si estaban aplicados a otras facturas).
                Los saldos de caja, cliente y de las otras facturas afectadas se revertirán automáticamente.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="rounded-sm">Cancelar</AlertDialogCancel>
          <AlertDialogAction
            data-testid="confirm-cascade-delete"
            onClick={onConfirm}
            className="rounded-sm bg-red-600 hover:bg-red-700"
          >
            Eliminar factura y {isVenta ? "cobros" : "pagos"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
